export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'CH',
  'merchantReturnLink': 'https://www.timberland.ch/fr-ch/aide-et-contact/retours',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
